import React, { createContext } from "react";

const CardContext = createContext();

export default CardContext;
